<div class="card-container width-100">

  <mat-card class="card">
    <mat-card-header class="card-header">
      <mat-card-title>Report Filter</mat-card-title>
    </mat-card-header>

    <mat-card-content class="card-content">
      <div fxLayout="column" fxAlign="center center">
        <div fxLayout="column" fxLayoutGap="20px">
          <form [formGroup]="formGroup" novalidate autocomplete="off" autocorrect="off">
            <div fxLayout="column">

            <!-- settlement_start_date -->
            <mat-form-field fxFlex>
              <input 
                readonly
                matInput 
                (click)="settlement_start_date.open()" 
                [matDatepicker]="settlement_start_date" 
                formControlName="settlement_start_date" 
                [placeholder]="('LABEL_SETTLEMENT_START_DATE' | translate)"
                [max]="maxStartDate"
                >
  
              <mat-datepicker-toggle matSuffix [for]="settlement_start_date"></mat-datepicker-toggle>
              <mat-datepicker #settlement_start_date></mat-datepicker>
  
              <mat-error *ngIf="formGroup.get('settlement_start_date').hasError('required')">
                {{ 'MSG_FIELD_REQUIRED' | translate }}
              </mat-error> 
            </mat-form-field>
  
            <!-- settlement_end_date -->
            <mat-form-field fxFlex>
              <input 
                readonly
                matInput 
                (click)="settlement_end_date.open()" 
                [matDatepicker]="settlement_end_date" 
                formControlName="settlement_end_date" 
                [placeholder]="('LABEL_SETTLEMENT_END_DATE' | translate)" 
                [min]="formGroup.get('settlement_start_date').value || null" 
                [max]="defaultEndDate"
                >
              
              <mat-datepicker-toggle matSuffix [for]="settlement_end_date"></mat-datepicker-toggle>
              <mat-datepicker #settlement_end_date></mat-datepicker>
  
              <mat-error *ngIf="formGroup.get('settlement_end_date').hasError('required')">
                {{ 'MSG_FIELD_REQUIRED' | translate }}
              </mat-error> 
            </mat-form-field>

            <!-- chain -->
            <mat-form-field class="width-100">
              <input 
                matInput
                required
                #chainInput
                formControlName="chain" 
                [matAutocomplete]="chainAC"
                [placeholder]="'LABEL_CHAIN' | translate" 
                (focus)="!chainAC.isOpen && getInitialData('chain')"
                >
          
              <mat-icon 
                matSuffix 
                color="primary"
                class="clear-input"
                svgIcon="close-circle"
                *ngIf="chainInput.value"
                (click)="resetControl(formGroup.get('chain')); chainInput.value = ''; autocompleteClose('chain', chainInput)"
                >
              </mat-icon>
          
              <mat-icon 
                matSuffix 
                class="clear-input"
                svgIcon="menu-down"
                *ngIf="!chainInput.value"
                >
              </mat-icon>
          
              <mat-autocomplete 
                [displayWith]="displayFn"
                #chainAC="matAutocomplete" 
                (opened)="autocompleteScroll('chain','chainACRef','chainACTr')"
                (closed)="autocompleteClose('chain', chainInput)"
                (optionSelected)="optionSelected('chain')"
                >
                <mat-option
                  disabled
                  *ngIf="!loading.chain && filterOptions.chain?.length == 0"
                  >
                  {{ 'MSG_NO_DATA' | translate }}
                </mat-option>
          
                <mat-option *ngFor="let item of filterOptions.chain" [value]="item">
                  {{ item.description }}
                </mat-option>
          
                <mat-option *ngIf="loading.chain" disabled>
                  <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
                </mat-option>
              </mat-autocomplete>
          
              <mat-error *ngIf="formGroup.controls['chain'].hasError('required')">
                {{ 'MSG_FIELD_REQUIRED' | translate }}
              </mat-error>   
      
              <mat-error *ngIf="formGroup.controls['chain'].hasError('notExisting')">
                  {{ 'MSG_DOESNT_EXIST' | translate: {type: ('LABEL_CHAIN' | translate)} }}
              </mat-error>
            </mat-form-field>
      
            <!-- island_group -->
            <mat-form-field class="width-100">
              <mat-chip-list #chipsIslandGroup aria-label="Island Group" [disabled]="formGroup.get('island_group').disabled">
                <mat-chip *ngFor="let data of multiSelect.selectedIslandGroups" [removable]="true" (removed)="toggleSelection(data, filterOptions.island_group, 'selectedIslandGroups', 'island_group')">
                  {{data.description}}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
              
                <input 
                  matInput
                  #island_groupInput 
                  [matChipInputFor]="chipsIslandGroup" 
                  formControlName="island_group" 
                  [matChipInputAddOnBlur]="true"
                  [matAutocomplete]="island_groupAC" 
                  (focus)="getInitialData('island_group')" 
                  (blur)="checkAutocompleteObject(formGroup, 'island_group', 'selectedIslandGroups')"
                  [placeholder]="'LABEL_ISLAND_GROUP' | translate" 
                  >
              
                <mat-icon 
                  matSuffix 
                  svgIcon="menu-down" 
                  *ngIf="!island_groupInput.value" 
                  class="autocomplete-arrow-color cursor-pointer"
                  (click)="island_groupInput.focus()" 
                  >
                </mat-icon>
              </mat-chip-list>
              
              <mat-autocomplete 
                [displayWith]="displayFn"
                #island_groupAC="matAutocomplete" 
                (opened)="autocompleteScroll('island_group','islGrpACRef','islGrpACTr')"
                (closed)="autocompleteClose('island_group', island_groupInput)"
                >
                <mat-option
                  disabled
                  *ngIf="!loading.island_group && filterOptions.island_group?.length == 0"
                  >
                  {{ 'MSG_NO_DATA' | translate }}
                </mat-option>
      
                <ng-container>
                  <mat-option *ngFor="let data of filterOptions.island_group" [value]="data" [disabled]="data.disabled">
                    <div (click)="!data.disabled && optionClicked($event, data, filterOptions.island_group, 'selectedIslandGroups', 'island_group', island_groupInput)" [class.disable]="data.disabled">
                      <mat-checkbox [checked]="data.selected" (change)="toggleSelection(data, filterOptions.island_group, 'selectedIslandGroups', 'island_group', island_groupInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled">
                        {{ data.description }}
                      </mat-checkbox>
                    </div>
                  </mat-option>
                </ng-container>
              
                <mat-option *ngIf="loading.island_group" disabled>
                  <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
                </mat-option>
              </mat-autocomplete>   
      
              <mat-error *ngIf="formGroup.controls['island_group'].hasError('notExisting')">
                {{'LABEL_ISLAND_GROUP' | translate}} doesn't exist
              </mat-error>
            </mat-form-field>
      
            <!-- region -->
            <mat-form-field class="width-100">
              <mat-chip-list #chipsRegion aria-label="Region" [disabled]="formGroup.get('region').disabled">
                <mat-chip *ngFor="let data of multiSelect.selectedRegions" [removable]="true" (removed)="toggleSelection(data, filterOptions.region, 'selectedRegions', 'region')">
                  {{data.description}}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
              
                <input 
                  matInput
                  #regionInput 
                  [matChipInputFor]="chipsRegion" 
                  formControlName="region" 
                  [matChipInputAddOnBlur]="true"
                  [matAutocomplete]="regionAC" 
                  (focus)="getInitialData('region')" 
                  (blur)="checkAutocompleteObject(formGroup, 'region', 'selectedRegions')"
                  [placeholder]="'LABEL_REGION' | translate" 
                  >
              
                <mat-icon 
                  matSuffix 
                  svgIcon="menu-down" 
                  *ngIf="!regionInput.value" 
                  class="autocomplete-arrow-color cursor-pointer"
                  (click)="regionInput.focus()" 
                  >
                </mat-icon>
              </mat-chip-list>
              
              <mat-autocomplete 
                [displayWith]="displayFn"
                #regionAC="matAutocomplete" 
                (opened)="autocompleteScroll('region','regionACRef','regionACTr')"
                (closed)="autocompleteClose('region', regionInput)"
                >
                <mat-option
                  disabled
                  *ngIf="!loading.region && filterOptions.region?.length == 0"
                  >
                  {{ 'MSG_NO_DATA' | translate }}
                </mat-option>
      
                <ng-container>
                  <mat-option *ngFor="let data of filterOptions.region" [value]="data" [disabled]="data.disabled">
                    <div (click)="!data.disabled && optionClicked($event, data, filterOptions.region, 'selectedRegions', 'region', regionInput)" [class.disable]="data.disabled">
                      <mat-checkbox [checked]="data.selected" (change)="toggleSelection(data, filterOptions.region, 'selectedRegions', 'region', regionInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled">
                        {{ data.description }}
                      </mat-checkbox>
                    </div>
                  </mat-option>
                </ng-container>
              
                <mat-option *ngIf="loading.region" disabled>
                  <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
                </mat-option>
              </mat-autocomplete>   
      
              <mat-error *ngIf="formGroup.controls['region'].hasError('notExisting')">
                {{'LABEL_REGION' | translate}} doesn't exist
              </mat-error>
            </mat-form-field>
      
            <!-- province -->
            <mat-form-field class="width-100">
              <mat-chip-list #chipsProvince aria-label="Province" [disabled]="formGroup.get('province').disabled">
                <mat-chip *ngFor="let data of multiSelect.selectedProvinces" [removable]="true" (removed)="toggleSelection(data, filterOptions.province, 'selectedProvinces', 'province')">
                  {{data.description}}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
              
                <input 
                  matInput
                  #provinceInput 
                  [matChipInputFor]="chipsProvince" 
                  formControlName="province" 
                  [matChipInputAddOnBlur]="true"
                  [matAutocomplete]="provinceAC" 
                  (focus)="getInitialData('province')" 
                  (blur)="checkAutocompleteObject(formGroup, 'province', 'selectedProvinces')"
                  [placeholder]="'LABEL_PROVINCE' | translate" 
                  >
              
                <mat-icon 
                  matSuffix 
                  svgIcon="menu-down" 
                  *ngIf="!provinceInput.value" 
                  class="autocomplete-arrow-color cursor-pointer"
                  (click)="provinceInput.focus()" 
                  >
                </mat-icon>
              </mat-chip-list>
              
              <mat-autocomplete 
                [displayWith]="displayFn"
                #provinceAC="matAutocomplete" 
                (opened)="autocompleteScroll('province','provinceACRef','provinceACTr')"
                (closed)="autocompleteClose('province', provinceInput)"
                >
                <mat-option
                  disabled
                  *ngIf="!loading.province && filterOptions.province?.length == 0"
                  >
                  {{ 'MSG_NO_DATA' | translate }}
                </mat-option>
      
                <ng-container>
                  <mat-option *ngFor="let data of filterOptions.province" [value]="data" [disabled]="data.disabled">
                    <div (click)="!data.disabled && optionClicked($event, data, filterOptions.province, 'selectedProvinces', 'province', provinceInput)" [class.disable]="data.disabled">
                      <mat-checkbox [checked]="data.selected" (change)="toggleSelection(data, filterOptions.province, 'selectedProvinces', 'province', provinceInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled">
                        {{ data.description }}
                      </mat-checkbox>
                    </div>
                  </mat-option>
                </ng-container>
              
                <mat-option *ngIf="loading.province" disabled>
                  <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
                </mat-option>
              </mat-autocomplete>   
      
              <mat-error *ngIf="formGroup.controls['province'].hasError('notExisting')">
                {{'LABEL_PROVINCE' | translate}} doesn't exist
              </mat-error>
            </mat-form-field>
            
            <!-- city -->
            <mat-form-field class="width-100">
              <mat-chip-list #chipsCity aria-label="City" [disabled]="formGroup.get('city').disabled">
                <mat-chip *ngFor="let data of multiSelect.selectedCities" [removable]="true" (removed)="toggleSelection(data, filterOptions.city, 'selectedCities', 'city')">
                  {{data.description}}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
              
                <input 
                  matInput
                  #cityInput 
                  [matChipInputFor]="chipsCity" 
                  formControlName="city" 
                  [matChipInputAddOnBlur]="true"
                  [matAutocomplete]="cityAC" 
                  (focus)="getInitialData('city')" 
                  (blur)="checkAutocompleteObject(formGroup, 'city', 'selectedCities')"
                  [placeholder]="'LABEL_CITY' | translate" 
                  >
              
                <mat-icon 
                  matSuffix 
                  svgIcon="menu-down" 
                  *ngIf="!cityInput.value" 
                  class="autocomplete-arrow-color cursor-pointer"
                  (click)="cityInput.focus()" 
                  >
                </mat-icon>
              </mat-chip-list>
              
              <mat-autocomplete 
                [displayWith]="displayFn"
                #cityAC="matAutocomplete" 
                (opened)="autocompleteScroll('city','cityACRef','cityACTr')"
                (closed)="autocompleteClose('city', cityInput)"
                >
                <mat-option
                  disabled
                  *ngIf="!loading.city && filterOptions.city?.length == 0"
                  >
                  {{ 'MSG_NO_DATA' | translate }}
                </mat-option>
      
                <ng-container>
                  <mat-option *ngFor="let data of filterOptions.city" [value]="data" [disabled]="data.disabled">
                    <div (click)="!data.disabled && optionClicked($event, data, filterOptions.city, 'selectedCities', 'city', cityInput)" [class.disable]="data.disabled">
                      <mat-checkbox [checked]="data.selected" (change)="toggleSelection(data, filterOptions.city, 'selectedCities', 'city', cityInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled">
                        {{ data.description }}
                      </mat-checkbox>
                    </div>
                  </mat-option>
                </ng-container>
              
                <mat-option *ngIf="loading.city" disabled>
                  <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
                </mat-option>
              </mat-autocomplete>   
      
              <mat-error *ngIf="formGroup.controls['city'].hasError('notExisting')">
                {{'LABEL_CITY' | translate}} doesn't exist
              </mat-error>
            </mat-form-field>
      
            <!-- campaign -->
            <mat-form-field class="width-100">
              <mat-chip-list #chipsCampaign aria-label="Campaign" [disabled]="formGroup.get('campaign').disabled">
                <mat-chip *ngFor="let data of multiSelect.selectedCampaigns" [removable]="true" (removed)="toggleSelection(data, filterOptions.campaign, 'selectedCampaigns', 'campaign')">
                  {{data.description}}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
              
                <input 
                  matInput
                  #campaignInput 
                  [matChipInputFor]="chipsCampaign" 
                  formControlName="campaign" 
                  [matChipInputAddOnBlur]="true"
                  [matAutocomplete]="campaignAC" 
                  (focus)="getInitialData('campaign')" 
                  (blur)="checkAutocompleteObject(formGroup, 'campaign', 'selectedCampaigns')"
                  [placeholder]="'LABEL_CAMPAIGN' | translate" 
                  >
              
                <mat-icon 
                  matSuffix 
                  svgIcon="menu-down" 
                  *ngIf="!campaignInput.value" 
                  class="autocomplete-arrow-color cursor-pointer"
                  (click)="campaignInput.focus()" 
                  >
                </mat-icon>
              </mat-chip-list>
              
              <mat-autocomplete 
                [displayWith]="displayFn"
                #campaignAC="matAutocomplete" 
                (opened)="autocompleteScroll('campaign','campaignACRef','campaignACTr')"
                (closed)="autocompleteClose('campaign', campaignInput)"
                >
                <mat-option
                  disabled
                  *ngIf="!loading.campaign && filterOptions.campaign?.length == 0"
                  >
                  {{ 'MSG_NO_DATA' | translate }}
                </mat-option>
      
                <ng-container>
                  <mat-option *ngFor="let data of filterOptions.campaign" [value]="data" [disabled]="data.disabled">
                    <div (click)="!data.disabled && optionClicked($event, data, filterOptions.campaign, 'selectedCampaigns', 'campaign', campaignInput)" [class.disable]="data.disabled">
                      <mat-checkbox [checked]="data.selected" (change)="toggleSelection(data, filterOptions.campaign, 'selectedCampaigns', 'campaign', campaignInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled">
                        {{ data.description }}
                      </mat-checkbox>
                    </div>
                  </mat-option>
                </ng-container>
              
                <mat-option *ngIf="loading.campaign" disabled>
                  <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
                </mat-option>
              </mat-autocomplete>   
      
              <mat-error *ngIf="formGroup.controls['campaign'].hasError('notExisting')">
                {{'LABEL_CAMPAIGN' | translate}} doesn't exist
              </mat-error>
            </mat-form-field>
      
            <!-- category -->
            <mat-form-field class="width-100">
              <mat-chip-list #chipsCategory aria-label="Category" [disabled]="formGroup.get('category').disabled">
                <mat-chip *ngFor="let data of multiSelect.selectedCategories" [removable]="true" (removed)="toggleSelection(data, filterOptions.category, 'selectedCategories', 'category')">
                  {{data.description}}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
              
                <input 
                  matInput
                  #categoryInput 
                  [matChipInputFor]="chipsCategory" 
                  formControlName="category" 
                  [matChipInputAddOnBlur]="true"
                  [matAutocomplete]="categoryAC" 
                  (focus)="getInitialData('category')" 
                  (blur)="checkAutocompleteObject(formGroup, 'category', 'selectedCategories')"
                  [placeholder]="'LABEL_CATEGORY' | translate" 
                  >
              
                <mat-icon 
                  matSuffix 
                  svgIcon="menu-down" 
                  *ngIf="!categoryInput.value" 
                  class="autocomplete-arrow-color cursor-pointer"
                  (click)="categoryInput.focus()" 
                  >
                </mat-icon>
              </mat-chip-list>
              
              <mat-autocomplete 
                [displayWith]="displayFn"
                #categoryAC="matAutocomplete" 
                (opened)="autocompleteScroll('category','categoryACRef','categoryACTr')"
                (closed)="autocompleteClose('category', categoryInput)"
                >
                <mat-option
                  disabled
                  *ngIf="!loading.category && filterOptions.category?.length == 0"
                  >
                  {{ 'MSG_NO_DATA' | translate }}
                </mat-option>
      
                <ng-container>
                  <mat-option *ngFor="let data of filterOptions.category" [value]="data" [disabled]="data.disabled">
                    <div (click)="!data.disabled && optionClicked($event, data, filterOptions.category, 'selectedCategories', 'category', categoryInput)" [class.disable]="data.disabled">
                      <mat-checkbox [checked]="data.selected" (change)="toggleSelection(data, filterOptions.category, 'selectedCategories', 'category', categoryInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled">
                        {{ data.description }}
                      </mat-checkbox>
                    </div>
                  </mat-option>
                </ng-container>
              
                <mat-option *ngIf="loading.category" disabled>
                  <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
                </mat-option>
              </mat-autocomplete>   
      
              <mat-error *ngIf="formGroup.controls['category'].hasError('notExisting')">
                {{'LABEL_CATEGORY' | translate}} doesn't exist
              </mat-error>
            </mat-form-field>
      
            <!-- brand -->
            <mat-form-field class="width-100">
              <mat-chip-list #chipsBrand aria-label="Brand" [disabled]="formGroup.get('brand').disabled">
                <mat-chip *ngFor="let data of multiSelect.selectedBrands" [removable]="true" (removed)="toggleSelection(data, filterOptions.brand, 'selectedBrands', 'brand')">
                  {{data.description}}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
              
                <input 
                  matInput
                  #brandInput 
                  [matChipInputFor]="chipsBrand" 
                  formControlName="brand" 
                  [matChipInputAddOnBlur]="true"
                  [matAutocomplete]="brandAC" 
                  (focus)="getInitialData('brand')" 
                  (blur)="checkAutocompleteObject(formGroup, 'brand', 'selectedBrands')"
                  [placeholder]="'LABEL_BRAND' | translate" 
                  >
              
                <mat-icon 
                  matSuffix 
                  svgIcon="menu-down" 
                  *ngIf="!brandInput.value" 
                  class="autocomplete-arrow-color cursor-pointer"
                  (click)="brandInput.focus()" 
                  >
                </mat-icon>
              </mat-chip-list>
              
              <mat-autocomplete 
                [displayWith]="displayFn"
                #brandAC="matAutocomplete" 
                (opened)="autocompleteScroll('brand','brandACRef','brandACTr')"
                (closed)="autocompleteClose('brand', brandInput)"
                >
                <mat-option
                  disabled
                  *ngIf="!loading.brand && filterOptions.brand?.length == 0"
                  >
                  {{ 'MSG_NO_DATA' | translate }}
                </mat-option>
      
                <ng-container>
                  <mat-option *ngFor="let data of filterOptions.brand" [value]="data" [disabled]="data.disabled">
                    <div (click)="!data.disabled && optionClicked($event, data, filterOptions.brand, 'selectedBrands', 'brand', brandInput)" [class.disable]="data.disabled">
                      <mat-checkbox [checked]="data.selected" (change)="toggleSelection(data, filterOptions.brand, 'selectedBrands', 'brand', brandInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled">
                        {{ data.description }}
                      </mat-checkbox>
                    </div>
                  </mat-option>
                </ng-container>
              
                <mat-option *ngIf="loading.brand" disabled>
                  <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
                </mat-option>
              </mat-autocomplete>   
      
              <mat-error *ngIf="formGroup.controls['brand'].hasError('notExisting')">
                {{'LABEL_BRAND' | translate}} doesn't exist
              </mat-error>
            </mat-form-field>
      
            <!-- item -->
            <mat-form-field class="width-100">
              <mat-chip-list #chipsItem aria-label="Item" [disabled]="formGroup.get('item').disabled">
                <mat-chip *ngFor="let data of multiSelect.selectedItems" [removable]="true" (removed)="toggleSelection(data, filterOptions.item, 'selectedItems', 'item')">
                  {{data.description}}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
              
                <input 
                  matInput
                  #itemInput 
                  [matChipInputFor]="chipsItem" 
                  formControlName="item" 
                  [matChipInputAddOnBlur]="true"
                  [matAutocomplete]="itemAC" 
                  (focus)="getInitialData('item')" 
                  (blur)="checkAutocompleteObject(formGroup, 'item', 'selectedItems')"
                  [placeholder]="'LABEL_ITEM' | translate" 
                  >
              
                <mat-icon 
                  matSuffix 
                  svgIcon="menu-down" 
                  *ngIf="!itemInput.value" 
                  class="autocomplete-arrow-color cursor-pointer"
                  (click)="itemInput.focus()" 
                  >
                </mat-icon>
              </mat-chip-list>
              
              <mat-autocomplete 
                [displayWith]="displayFn"
                #itemAC="matAutocomplete" 
                (opened)="autocompleteScroll('item','itemACRef','itemACTr')"
                >
                <mat-option
                  disabled
                  *ngIf="!loading.item && filterOptions.item?.length == 0"
                  >
                  {{ 'MSG_NO_DATA' | translate }}
                </mat-option>
      
                <ng-container>
                  <mat-option *ngFor="let data of filterOptions.item" [value]="data" [disabled]="data.disabled">
                    <div (click)="!data.disabled && optionClicked($event, data, filterOptions.item, 'selectedItems', 'item', itemInput)" [class.disable]="data.disabled">
                      <mat-checkbox [checked]="data.selected" (change)="toggleSelection(data, filterOptions.item, 'selectedItems', 'item', itemInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled">
                        {{ data.description }}
                      </mat-checkbox>
                    </div>
                  </mat-option>
                </ng-container>
              
                <mat-option *ngIf="loading.item" disabled>
                  <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
                </mat-option>
              </mat-autocomplete>   
      
              <mat-error *ngIf="formGroup.controls['item'].hasError('notExisting')">
                {{'LABEL_ITEM' | translate}} doesn't exist
              </mat-error>
            </mat-form-field>

            </div>
          </form>
        </div>
      </div>
    </mat-card-content>

    <mat-card-actions class="card-actions">
      <div *ngIf="!media.isActive('lt-sm')" fxLayout fxLayoutAlign="end center">
        <button id="id_reset_filter_btn" type="button" color="warn" mat-button (click)="reset()">
          {{ 'LABEL_RESET' | translate }}
        </button>
        <button id="id_cancel_filter_btn" type="button" color="primary" mat-raised-button [disabled]="isGenerateReportDisabled()" (click)="generateReport()">
          {{ 'LABEL_GENERATE_REPORT' | translate }}
        </button>
      </div>

      <!-- buttons for mobile view -->
      <div *ngIf="media.isActive('lt-sm')" fxLayout fxLayoutAlign="end center">
        <button id="id_reset_filter_btn" type="button" color="warn" mat-icon-button (click)="reset()">
          <mat-icon svgIcon="restore"></mat-icon>
        </button>

        <button id="id_apply_filter_btn" type="button" color="primary" mat-icon-button [disabled]="isGenerateReportDisabled()" (click)="generateReport()">
          <mat-icon svgIcon="check"></mat-icon>
        </button>
      </div>
    </mat-card-actions>
  </mat-card>

  <div *ngIf="loading.export" fxFlex fxLayout="column" fxLayoutAlign="center center" class="loading-indicator-report">
    <mat-spinner></mat-spinner>
  </div>
</div>